import { createBreakpoints } from "@chakra-ui/theme-tools"

const breakpoints = createBreakpoints({
  sm: "25em",
  "2xl": "96em",
  "3xl": "120em",
})

export default breakpoints
